import { connect } from 'react-redux';
// import {  } from '../reducers/auth.reducers';
import {
  loadSocialWallPostsAction,
  removeImageForSocialPostAction,
  createSocialWallPostAction,
  updateSocialWallPostAction,
} from '../../reducers/socialwall.reducers';
import { errorNotification } from '../../reducers/notification.reducers';
import SocialWall from './socialwall';

const mapDispatchToProps = dispatch => ({
  loadSocialPosts: dto => dispatch(loadSocialWallPostsAction(dto)),
  showError: error => dispatch(errorNotification(error)),
  removeImage: url => dispatch(removeImageForSocialPostAction(url)),
  createPost: dto => dispatch(createSocialWallPostAction(dto)),

});

const mapStateToProps = state => ({
  posts: state.socialwall.posts,
  postsLoading: state.socialwall.socialPostsLoading,
  totalCount: state.socialwall.totalCount,
  userGroups: state.authentication.userGroups,
  roles: state.authentication.roles,
  user: state.authentication.user,
});

export default connect(mapStateToProps, mapDispatchToProps)(SocialWall);



// WEBPACK FOOTER //
// ./src/app/main/socialwall/socialwall.container.js